/**
 * `constants.ts` class for EJ2-PDF
 * @private
 */
var ProcedureSets = /** @class */ (function () {
    function ProcedureSets() {
        /**
         * Specifies the `PDF` procedure set.
         * @private
         */
        this.pdf = 'PDF';
        /**
         * Specifies the `Text` procedure set.
         * @private
         */
        this.text = 'Text';
        /**
         * Specifies the `ImageB` procedure set.
         * @private
         */
        this.imageB = 'ImageB';
        /**
         * Specifies the `ImageC` procedure set.
         * @private
         */
        this.imageC = 'ImageC';
        /**
         * Specifies the `ImageI` procedure set.
         * @private
         */
        this.imageI = 'ImageI';
    }
    return ProcedureSets;
}());
export { ProcedureSets };



//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/node_modules/@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-pdf-export/src/implementation/graphics/constants.js
// module id = ../../../../@syncfusion/ej2-angular-pdfviewer/node_modules/@syncfusion/ej2-pdf-export/src/implementation/graphics/constants.js
// module chunks = vendor